export default __webpack_public_path__ + "static/ds_03-d1231b5d07cbd0348d0c8791edd4c266.png";